import useFacebookPost from "../../hooks/useFacebookPost";
import SpinnerLoading from "../../components/util/spinnerLoader";
// import GoogleAdsense from "../../components/googleAdsense";
import PageSEO from "../../components/SEO/PageSEO";

import styles from "./facebookPhotos.module.css";

export default function FacebookPhotos() {
    const breadcrumbItems = [
        { name: "Inicio", url: "/" },
        { name: "Registro Fotográfico", url: "/fotos" }
    ];

    const {
        photos,
        loading,
        error,
        currentPage,
        currentPhotos,
        totalPages,
        handleNextPage,
        handlePrevPage
    } = useFacebookPost();

    if(loading)
    return (
      <div className={styles.loading}>
        <SpinnerLoading />
      </div>
    );
  if (error) return <div className={styles.error}>{error}</div>;
  if (photos.length === 0)
    return <div className={styles.loading}>No se encontraron fotos.</div>;

  return (
    <>
      <PageSEO
        title="Registro Fotográfico - Punk Medallo"
        description="Galería de fotos y eventos de Punk Medallo. Revive los mejores momentos del punk en Medellín a través de nuestro registro fotográfico."
        canonicalPath="/fotos"
        breadcrumbItems={breadcrumbItems}
      />
      <div className={styles.container}>
      <h2 className={styles.title}>Registro Fotográfico</h2>

      {/* Anuncio 1 */}
      {/* <GoogleAdsense
        adSlot="6789012345"
        adFormat="auto"
      /> */}

      <div className={styles.grid}>
        {currentPhotos.map((photo) => (
          <div key={photo.id} className={styles.card}>
            <img
              src={photo.full_picture}
              alt={photo.message || "Facebook post"}
              className={styles.image}
              loading="lazy"
            />
            <a
              href={photo.permalink_url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.overlay}
            >
              <span className={styles.viewButton}>Ver en Facebook</span>
            </a>
            {photo.message && (
              <div className={styles.message}>{photo.message}</div>
            )}
          </div>
        ))}
      </div>

      {/* Anuncio 2 */}
      {/* <GoogleAdsense
        adSlot="7890123456"
        adFormat="auto"
      /> */}

      {/* Controles de Paginación */}
      <div className={styles.paginationContainer}>
        <button
          className={styles.paginationBtn}
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          ← Anterior
        </button>

        <span className={styles.pageInfo}>
          Página {currentPage} de {totalPages}
        </span>

        <button
          className={styles.paginationBtn}
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Siguiente →
        </button>
       </div>
      </div>
    </>
  );
}
